import React, { Component } from "react";
import classNames from 'classnames';

import BaseLayout from "../../containers/BaseLayout";
import Notification from "../../containers/Notification";

class FullPageLayout extends Component {
  gridClassName() {
    return classNames(
      'grid',
      this.props.gridClassName
    )
  }

  render() {
    return (
      <BaseLayout>
        <Notification />
        <div className={this.gridClassName()}>
          {this.props.children}
        </div>
      </BaseLayout>
    )
  }
}

export default FullPageLayout;



// WEBPACK FOOTER //
// ./src/features/shared/components/layouts/FullPageLayout.js